<template>
  <div class="register">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <div class="px-5 mx-auto">
            <img src="logo.png" alt="Logo" />
          </div>

          <h1 class="mb-6">Política de Tratamiento de Datos personales</h1>

          <p class="text-justify">
            En cumplimiento de la Ley 1581 de 2012 y demás normas aplicables
            sobre la materia con el fin de ejercer el derecho de protección de
            datos personales, la persona que se registra en el autoservicio de
            admisiones (Aspirantes, Admitidos, Colaboradores, Supervisores), de
            la Corporación Lideres Impactando Vidas con Excelencia- Corporación
            Live- manifiesta que: 1. Ha sido informado y entiende la Directriz
            de Tratamiento de Datos Personales de la CORPORACION LIDERES
            IMPACTANDO VIDAS CON EXCELENCIA- CORPORACION LIVE- (en adelante “LA
            CORPORACION”), en caso de desconocerla podrá consultarla en la
            pagina de LA CORPORACION en el enlace
            <a
              href="http://app.corporacionlive.com/tratamiento_datos_personales"
              target="_blank"
              @click.stop
              >www.app.corporacionlive.com/tratamiento_datos_personales</a
            >
            o solicitarla en todo momento a través del siguiente correo
            electrónico:
            <a href="mailto:corporacionlive@gmail.com"
              >corporacionlive@gmail.com</a
            >. En ese sentido, otorga su consentimiento expreso para que sus
            datos personales sean tratados conforme a lo establecido en la
            Directriz de Tratamiento de Datos Personales y demás políticas
            internas relativas al tratamiento de datos personales. 2. Autoriza
            el tratamiento de los datos registrados en el autoservicio de
            admisiones que incluye el procesamiento, recolección,
            almacenamiento, uso, circulación, supresión, actualización,
            transmisión y/o transferencia nacional e internacional de los datos
            suministrados. La presente autorización estará vigente hasta tanto
            sea revocada expresamente por quien la otorga. 3. Los fines para los
            cuales se solicitan sus datos personales son: 3.1) Realizar el
            proceso de vinculación a la corporación. 3.2) Realizar el proceso de
            selección y admisión de la Corporación. 3.3) Realizar envíos de
            información sobre los procesos de admisión, y promoción de programas
            académicos de la Corporación. 3.4) Generar los procesos de
            contratación relacionada con el proceso de admisión. 3.5) Realizar
            promoción, ejecución, desarrollo, evaluación de las siguientes
            actividades académicas, administrativas y bienestar de la
            corporación y de los corporados: 3.5.1. Programas y proyectos de
            formación de personas. 3.5.2. Desarrollo y creación de conocimiento.
            3.5.3 Aplicación y/o transferencia de conocimiento a la sociedad o a
            sus sectores. 3.6) Realizar promoción, ejecución, desarrollo,
            evaluación de programas de responsabilidad social y apoyo a
            comunidades vulnerables. 3.7) Realizar promoción, ejecución,
            desarrollo, evaluación para lograr la consolidación de la comunidad
            educativa, incluyendo a sus estamentos. 3.8) Realizar promoción,
            ejecución, desarrollo y evaluación de los procesos administrativos
            que faciliten la actividad y los servicios de la corporación. 3.9)
            Atención de requerimientos judiciales o administrativos. 3.10)
            Cumplimiento de mandatos judiciales o legales. 4. Todos los datos
            personales suministrados son ciertos y no ha omitido ni alterado
            información alguna. 5. He sido informado por la CORPORACION de sus
            derechos de conocer, actualizar, rectificar y suprimir sus datos
            personales, así como la posibilidad de acceder en cualquier momento
            a los datos suministrados y el procedimiento para solicitar su
            corrección, actualización o supresión de las bases de datos de LA
            CORPORACION LIDERES IMPACTANDO VIDAS CON EXCELENCIA- Corporación
            Live-, dirigiéndome al siguiente punto de contacto
            <a href="mailto:corporacionlive@gmail.com"
              >corporacionlive@gmail.com</a
            >.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "Term",
};
</script>

